import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {ReactComponent as CaretArrow} from "../assets/image/caret-right.svg"

import { ReactComponent as CaseSvg } from "../assets/image/tabs/case.svg";
import { ReactComponent as StarSvg } from "../assets/image/Star.svg";

import { ReactComponent as HistorySvg } from "../assets/image/badges/history.svg";
import { ReactComponent as SettingsSvg } from "../assets/image/badges/settings.svg";
import { ReactComponent as FaqSvg } from "../assets/image/badges/help.svg";
import { ReactComponent as MessageSvg } from "../assets/image/badges/message-question.svg";
import { ReactComponent as DocumentSvg } from "../assets/image/badges/document.svg";

import { ReactComponent as LangSvg } from "../assets/image/badges/globe-alt.svg";
import { ReactComponent as ThemeSvg } from "../assets/image/badges/roller-paint-brush.svg";
import { ReactComponent as SoundSvg } from "../assets/image/badges/volume-high.svg";
import { ReactComponent as VibroSvg } from "../assets/image/badges/phone-vibrate.svg";

import ProfileBanner from "../assets/image/profile-banner.svg"

import CustomButton from '../components/CustomButton';
import BaseModal from "../components/BaseModal";

import { Trans, useTranslation } from "react-i18next";

import i18n from "../i18n"; 

export default function Profile({}) {
    const [activeModal, setActiveModal] = useState(null);
    const openModal = (name) => setActiveModal(name);
    const closeModal = () => setActiveModal(null);

    const [selectedLang, setSelectedLang] = useState(() => {
        const saved = localStorage.getItem("lang");
        return saved ? saved : "en"; // 1 = темная, 2 = светлая
    });

    const { t } = useTranslation();

    const languages = {
        "ru": "Русский",
        "en": "English"
    };

    const themes = {
        1: t("profile.buttons.settings.modal.buttons.theme.dark"),
        2: t("profile.buttons.settings.modal.buttons.theme.light")
    };

    const [selectedTheme, setSelectedTheme] = useState(() => {
        const saved = localStorage.getItem("theme");
        return saved ? Number(saved) : 1; // 1 = темная, 2 = светлая
    });

    const [isAudioEnabled, setIsAudioEnabled] = useState(() => {
        const saved = localStorage.getItem("audio");
        if (saved === null || saved === undefined) {
            return true;
        }
        return saved === "1"; // 1 = вкл, 2 = выкл
    });

    const navigate = useNavigate();

    useEffect(() => {
        if (selectedTheme === 1) {
            document.body.classList.remove("light-theme");
        } else {
            document.body.classList.add("light-theme");
        }

        localStorage.setItem("theme", selectedTheme);
    }, [selectedTheme]);

    useEffect(() => {
        i18n.changeLanguage(selectedLang);
        localStorage.setItem("lang", selectedLang);
    }, [selectedLang]);

    useEffect(() => {
        localStorage.setItem("audio", isAudioEnabled ? "1" : "0");
    }, [isAudioEnabled]);

  return (
    <>
    <div style={{display: "flex", flexDirection: "column", gap: "20px", alignItems: "center"}}>
        <div style={{display: "flex", flexDirection: "column", gap: "12px", alignItems: "center", width: "100%"}}>
            <div className='dark-box profile'>
                <img className='avatar' src="/images/fake-avatar.png" alt="avatar"/>
                <div style={{display: "flex", flexDirection: "column", gap: "15px", alignItems:"start", width: "100%"}}>
                    <div style={{display: "flex", flexDirection: "column",}}>
                        <h3>Pavel Durov</h3>
                        <span>@durov</span>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", gap: "12px", width: "100%"}} onClick={() => openModal("levels")}> 
                        <div style={{display: "flex", flexDirection: "column", gap: "4px", width: "100%"}}>
                            <div style={{display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", alignItems: "center"}}>
                                <span className="xp-text"><Trans i18nKey="profile.xp-text" values={{ my: 148, need: 250 }} /></span>
                                <span className="level-text"><Trans i18nKey="profile.my-level" values={{ level: 4 }} /></span>
                            </div>
                            <div className="level-bar">
                                <div class="progress-fill" style={{width: "70%"}}/>
                            </div>
                        </div>
                        <CaretArrow className='grey-svg svg-24-24' />
                    </div>
                </div>
            </div>
            <div  
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gridTemplateRows: "repeat(2, 1fr)",
                    gap: "12px",
                    width: "100%",
                }}
            >
                <div className='dark-box ref-stat'>
                    <span className='ref-header'><CaseSvg className='white-svg svg-30-30' />63</span>
                    <span className="main text-center"><Trans i18nKey="profile.stats.opened" /></span>
                </div>
                <div className='dark-box ref-stat'>
                    <span className='ref-header'><StarSvg className='white-svg svg-30-30' />124 879</span>
                    <span className="main text-center"><Trans i18nKey="profile.stats.win" /></span>
                </div>
                <div className='dark-box ref-stat'>
                    <span className='ref-header'><StarSvg className='white-svg svg-30-30' />64 158</span>
                    <span className="main text-center"><Trans i18nKey="profile.stats.selled" /></span>
                </div>
                <div className='dark-box ref-stat'>
                    <span className='ref-header'><StarSvg className='white-svg svg-30-30' />50 000</span>
                    <span className="main text-center"><Trans i18nKey="profile.stats.best" /></span>
                </div>
            </div> 
        </div>
        <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "center", width: "100%"}}>
            <CustomButton
                Icon={HistorySvg}
                label={<Trans i18nKey="profile.buttons.history.text" />}
                type={1}
                background_color="var(--modal-background-color)"
            />
            <CustomButton
                Icon={SettingsSvg}
                label={<Trans i18nKey="profile.buttons.settings.text" />}
                type={1}
                background_color="var(--modal-background-color)"
                onClick={() => openModal("settings")}
            />
            <CustomButton
                Icon={FaqSvg}
                label={<Trans i18nKey="profile.buttons.faq.text" />}
                type={1}
                background_color="var(--modal-background-color)"
                onClick={() => navigate("/faq")}
            />
            <CustomButton
                Icon={MessageSvg}
                label={<Trans i18nKey="profile.buttons.support.text" />}
                type={1}
                background_color="var(--modal-background-color)"
            />
            <CustomButton
                Icon={DocumentSvg}
                label={<Trans i18nKey="profile.buttons.agreement.text" />}
                type={1}
                background_color="var(--modal-background-color)"
                onClick={() => navigate("/terms")}
            />
        </div>
        
        {/* Настройки */}
        <BaseModal
            headerName={<Trans i18nKey="profile.buttons.settings.modal.header" />}
            show={activeModal === "settings"}
            onClose={closeModal}
        >
            <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "center", width: "100%"}}>
                <CustomButton
                    Icon={LangSvg}
                    label={<Trans i18nKey="profile.buttons.settings.modal.buttons.language.text" />}
                    type={1}
                    background_color="var(--dark-grey-back)"
                    extra={languages[selectedLang]}
                    onClick={() => openModal("language")}
                />
                <CustomButton
                    Icon={ThemeSvg}
                    label={<Trans i18nKey="profile.buttons.settings.modal.buttons.theme.text" />}
                    type={1}
                    background_color="var(--dark-grey-back)"
                    extra={themes[selectedTheme]}
                    onClick={() => openModal("theme")}
                />
                <CustomButton
                    Icon={SoundSvg}
                    label={<Trans i18nKey="profile.buttons.settings.modal.buttons.audio.text" />}
                    type={2}
                    background_color="var(--dark-grey-back)"
                    checked={isAudioEnabled}
                    onChange={() => setIsAudioEnabled(prev => !prev)}
                />
                <CustomButton
                    Icon={VibroSvg}
                    label={<Trans i18nKey="profile.buttons.settings.modal.buttons.vibro.text" />}
                    type={2}
                    background_color="var(--dark-grey-back)"
                    checked={true}
                />
            </div>
        </BaseModal>
        
        {/* Язык */}
        <BaseModal
            headerName={<Trans i18nKey="profile.buttons.settings.modal.buttons.language.text" />}
            show={activeModal === "language"}
            onClose={() => {
                closeModal();
                openModal("settings");
            }}
        >
            <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "center", width: "100%"}}>
                <CustomButton
                    label="Русский"
                    type={3}
                    checked={selectedLang === "ru"}
                    onChange={() => setSelectedLang("ru")}
                    background_color="var(--dark-grey-back)"
                />
                <CustomButton
                    label="English"
                    type={3}
                    checked={selectedLang === "en"}
                    onChange={() => setSelectedLang("en")}
                    background_color="var(--dark-grey-back)"
                />
            </div>
        </BaseModal>
        
        {/* Тема */}
        <BaseModal
            headerName={<Trans i18nKey="profile.buttons.settings.modal.buttons.theme.text" />}
            show={activeModal === "theme"}
            onClose={() => {
                closeModal();
                openModal("settings");
            }}
        >
            <div style={{display: "flex", flexDirection: "column", gap: "8px", alignItems: "center", width: "100%"}}>
                <CustomButton
                    label={<Trans i18nKey="profile.buttons.settings.modal.buttons.theme.dark" />}
                    type={3}
                    checked={selectedTheme === 1}
                    onChange={() => setSelectedTheme(1)}
                    background_color="var(--dark-grey-back)"
                />
                <CustomButton
                    label={<Trans i18nKey="profile.buttons.settings.modal.buttons.theme.light" />}
                    type={3}
                    checked={selectedTheme === 2}
                    onChange={() => setSelectedTheme(2)}
                    background_color="var(--dark-grey-back)"
                />
            </div>
        </BaseModal>

        {/* LVL */}
        <BaseModal
            headerName={<Trans i18nKey="profile.level-modal.header" />}
            show={activeModal === "levels"}
            onClose={() => {closeModal();}}
        >
        <div style={{display: "flex", flexDirection: "column", gap: "4px", width: "100%"}}>
            <div style={{display: "flex", flexDirection: "row", width: "100%", justifyContent: "space-between", alignItems: "center"}}>
                <span className="xp-text"><Trans i18nKey="profile.xp-text" values={{ my: 148, need: 250 }} /></span>
                <span className="level-text"><Trans i18nKey="profile.my-level" values={{ level: 4 }} /></span>
            </div>
            <div className="level-bar">
                <div className="progress-fill" style={{width: "70%"}}/>
            </div>
        </div>
        <div style={{display: "flex", flexDirection: "column", width: "100%", alignItems: "start", gap: "8px"}}>
            <span className="level-modal-text"><Trans i18nKey="profile.level-modal.what-this" /></span>
            <div>
                <h4 className="level-modal-header"><Trans i18nKey="profile.level-modal.star-case-header" /></h4>
                <span className="level-modal-text"><Trans i18nKey="profile.level-modal.star-case-text" components={{ highlight: <span className="highlight" />, br: <br/>, b: <b/> }}/></span>
            </div>
            <div>
                <h4 className="level-modal-header"><Trans i18nKey="profile.level-modal.ref-system-header" /></h4>
                <span className="level-modal-text"><Trans i18nKey="profile.level-modal.ref-system-text" components={{ highlight: <span className="highlight" />, br: <br/>, b: <b/> }}/></span>
            </div>
        </div>
        <button className="default-blue-button" onClick={() => {closeModal();}}><Trans i18nKey="profile.level-modal.button" /></button>
        </BaseModal>
    </div>
    </>
  );
}
